export interface Recipe {
  id: string;
  title: string;
  ingredients: string[];
  instructions: string[];
  createdAt: string;
  updatedAt: string;
}

export const mockRecipes: Recipe[] = [
  {
    id: "1",
    title: "Борщ классический",
    ingredients: [
      "500 г говядины на кости",
      "3 средних свёклы",
      "2 картофелины",
      "1 морковь",
      "1 луковица",
      "300 г капусты",
      "2 ст. л. томатной пасты",
      "3 зубчика чеснока",
      "Лавровый лист, соль, перец",
      "Сметана для подачи",
      "Свежий укроп",
    ],
    instructions: [
      "Сварите мясной бульон из говядины в течение 1,5 часов, снимая пену. Мясо выньте и нарежьте кусочками.",
      "Свёклу натрите на крупной тёрке, обжарьте на сковороде с томатной пастой 7–8 минут на среднем огне.",
      "В кипящий бульон положите нарезанный кубиками картофель, варите 10 минут.",
      "Морковь натрите на тёрке, лук мелко нарежьте и обжарьте до мягкости.",
      "Добавьте в кастрюлю нашинкованную капусту и зажарку из лука и моркови.",
      "Через 5 минут добавьте свёклу с томатной пастой и нарезанное мясо.",
      "Варите 10 минут, добавьте чеснок через пресс, лавровый лист, соль и перец по вкусу.",
      "Дайте настояться 20 минут. Подавайте со сметаной и свежим укропом.",
    ],
    createdAt: "2026-04-10T14:30:00Z",
    updatedAt: "2026-04-10T14:30:00Z",
  },
  {
    id: "2",
    title: "Сырники из творога",
    ingredients: [
      "500 г творога (9%)",
      "2 яйца",
      "3 ст. л. сахара",
      "4 ст. л. муки",
      "Щепотка соли",
      "1 ч. л. ванильного сахара",
      "Растительное масло для жарки",
      "Сметана или варенье для подачи",
    ],
    instructions: [
      "Протрите творог через сито или разомните вилкой до однородной массы — это сделает сырники нежными.",
      "Добавьте яйца, сахар, ванильный сахар и щепотку соли. Хорошо перемешайте.",
      "Всыпьте муку и аккуратно замесите тесто. Оно должно быть мягким, слегка липким.",
      "Сформируйте сырники толщиной около 1,5 см, обваляйте в муке.",
      "Разогрейте сковороду с маслом на среднем огне. Выложите сырники.",
      "Жарьте по 3–4 минуты с каждой стороны до золотистой корочки.",
      "Подавайте горячими со сметаной, вареньем или свежими ягодами.",
    ],
    createdAt: "2026-04-09T09:15:00Z",
    updatedAt: "2026-04-09T09:15:00Z",
  },
  {
    id: "3",
    title: "Оливье",
    ingredients: [
      "4 картофелины",
      "3 яйца",
      "200 г варёной колбасы",
      "3 маринованных огурца",
      "1 банка зелёного горошка",
      "1 морковь",
      "Майонез по вкусу",
      "Соль, перец по вкусу",
      "Свежий укроп для украшения",
    ],
    instructions: [
      "Отварите картофель и морковь в мундире до готовности — около 25 минут. Остудите и очистите.",
      "Яйца сварите вкрутую (10 минут после закипания), остудите под холодной водой и очистите.",
      "Все отварные овощи и яйца нарежьте мелкими кубиками одинакового размера.",
      "Колбасу и маринованные огурцы нарежьте такими же кубиками.",
      "Смешайте всё в большой миске, добавьте горошек (слить жидкость).",
      "Заправьте майонезом, посолите и поперчите по вкусу. Перемешайте.",
      "Уберите в холодильник минимум на 1 час — салат станет вкуснее, когда настоится.",
    ],
    createdAt: "2026-04-08T18:00:00Z",
    updatedAt: "2026-04-08T18:00:00Z",
  },
  {
    id: "4",
    title: "Блины на молоке",
    ingredients: [
      "500 мл молока",
      "2 яйца",
      "200 г муки",
      "2 ст. л. сахара",
      "1 ст. л. растительного масла",
      "Щепотка соли",
      "Сливочное масло для смазывания",
    ],
    instructions: [
      "Яйца взбейте с сахаром и солью до лёгкой пены.",
      "Влейте половину молока (тёплого), перемешайте.",
      "Добавьте просеянную муку и тщательно размешайте до однородности, чтобы не было комочков.",
      "Влейте оставшееся молоко и растительное масло. Тесто должно быть как жидкая сметана.",
      "Дайте тесту отдохнуть 15–20 минут при комнатной температуре.",
      "Разогрейте сковороду, слегка смажьте маслом. Наливайте тесто тонким слоем, поворачивая сковороду.",
      "Жарьте каждый блин около 1–1,5 минуты с каждой стороны до золотистого цвета.",
      "Готовые блины смажьте сливочным маслом и подавайте со сметаной, мёдом или вареньем.",
    ],
    createdAt: "2026-04-07T08:00:00Z",
    updatedAt: "2026-04-07T08:00:00Z",
  },
  {
    id: "5",
    title: "Пельмени домашние",
    ingredients: [
      "Для теста: 400 г муки",
      "1 яйцо",
      "150 мл воды",
      "1 ч. л. соли",
      "Для начинки: 300 г свинины",
      "200 г говядины",
      "1 луковица",
      "2 зубчика чеснока",
      "Соль, перец по вкусу",
    ],
    instructions: [
      "Замесите тесто: в горку муки добавьте яйцо, соль и воду. Вымешивайте 10 минут до гладкости.",
      "Оберните тесто в плёнку и оставьте отдохнуть на 30 минут.",
      "Приготовьте начинку: пропустите мясо с луком и чесноком через мясорубку. Посолите и поперчите.",
      "Раскатайте тесто тонко (2 мм), вырежьте кружки стаканом диаметром 6–7 см.",
      "На каждый кружок положите чайную ложку начинки, защипните края.",
      "Соедините уголки пельменя вместе — получится характерная форма.",
      "Варите в подсоленной кипящей воде 7–8 минут после всплытия.",
      "Подавайте со сметаной, уксусом или сливочным маслом.",
    ],
    createdAt: "2026-04-06T12:45:00Z",
    updatedAt: "2026-04-06T12:45:00Z",
  },
];

export function getRecipes(): Recipe[] {
  return [...mockRecipes];
}

export function getRecipeById(id: string): Recipe | undefined {
  return mockRecipes.find((r) => r.id === id);
}

export function generateId(): string {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
}
